import { render, staticRenderFns } from "./clientData.vue?vue&type=template&id=d889172e&scoped=true&"
import script from "./clientData.vue?vue&type=script&lang=js&"
export * from "./clientData.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=d889172e&scoped=true&lang=css&"
import style1 from "./clientData.vue?vue&type=style&index=1&id=d889172e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d889172e",
  null
  
)

export default component.exports